import { CmsApiAccordionBlockData } from 'modules/cms/api/types/blocks/CmsApiAccordionBlock';
import { CmsAccordionBlock } from 'modules/cms/blocks/Accordion/CmsAccordionBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpAccordionBlock } from './CmsAmpAccordionBlock';

export const CmsAccordionBlockMapping: CmsBlockMapping<CmsApiAccordionBlockData> =
  {
    invariant: [
      {
        prop: 'sections',
        msg: 'Sections required for accordion',
      },
    ],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsAccordionBlock,
    AmpComponent: CmsAmpAccordionBlock,
  };
